import React, { FC } from 'react'
import { List, ListItem, BoxProps, css, useTheme, Box } from '@chakra-ui/core'

export interface Props extends BoxProps {
  items: string[]
}

export const UnorderedList: FC<Props> = ({ items }) => {
  const theme = useTheme()

  const verticalLine = css({
    top: '0.1rem',
    borderLeft: `0.1rem solid ${theme.colors.gray[400]}`,
  })(theme)

  const verticalLineLast = css({
    top: '-0.3rem',
    height: '0.95rem',
    borderLeft: `0.1rem solid ${theme.colors.gray[400]}`,
  })(theme)

  return (
    <List styleType="none" my="0.4rem">
      {items.map((item: string, index: number) => (
        <ListItem
          key={item + index}
          margin="0"
          padding="0 0.8rem"
          position="relative"
          lineHeight="1.2rem"
          fontSize="0s.9rem"
          color="gray.100"
          display="flex"
          verticalAlign="center"
        >
          <Box
            position="relative"
            width="0.1rem"
            display="inline-block"
            left="-0.8rem"
            style={items.length === index + 1 ? verticalLineLast : verticalLine}
          ></Box>
          <Box
            position="relative"
            top="0.45rem"
            height="0.2rem"
            width="0.4rem"
            borderBottom="1px solid"
            borderColor="gray.400"
            display="inline-block"
            left="-0.9rem"
          ></Box>
          <Box
            position="absolute"
            left="0.3rem"
            top="0.4rem"
            display="inline-block"
            width="0.4rem"
            height="0.4rem"
            borderRadius="0.1rem"
            backgroundColor="gray.50"
          ></Box>
          {item}
        </ListItem>
      ))}
    </List>
  )
}
